<template>
  <div class="s_ptb0lr24 s_bf">
    <div class="fz-18 s_hei60 s_ptb0lr24 s_flex_ali s_bf58">
      <a-button size='small' @click="()=>{$router.go(-1)}" class="mr10"><LeftOutlined />返回</a-button>
      {{$route.query.name}}
    </div>
  </div>
  <a-card :bordered='false'>
    <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
      layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="product_name">商品名称</a-select-option>
            <a-select-option value="product_sn">商品编号</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <p class="p-b-20">库存总数量：{{$route.query.num}}</p>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='product_sn' :columns='columns' :data-source='list'>
       <template v-slot:code="{ record }">
         <div v-if="record.product_sku_sn!=='0'">{{record.product_sku_sn}}</div>
          <div v-else>{{record.product_sn}}</div>
      </template>
      <template v-slot:action="{ record }">
        <a @click="()=> {$router.push('/antiFleeingGoods/marketAudit/warningDetails?id='+record.dealer_id)}"
          href="javascript:;">查看全部记录</a>
      </template>
    </a-table>
    <div class="s_flex_bian_c m-t-20">
      <a-button class="width-100" block @click="()=>{$router.go(-1)}">返回</a-button>
      <a-pagination :style="{textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
      :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"/>
    </div>
  </a-card>
</template>
<script>
  import { LeftOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import { getStockMore } from "@/api/antiFleeing";
  // 初始化默认筛选项数值
  let defSearch = {
    id: "",
    type: 1,
    status:2,
    page: 1,
    limit: 10,
    key_type: "product_name",
    keyword: "",
  };
  export default {
    components: {LeftOutlined},
    setup() {
      const state = reactive({
        time: [],
        columns: [
          {
            title: "商品编号",
            // dataIndex: "product_sn",
            key: "product_sn",
             slots: { customRender: "code" },
          },
          {
            title: "商品名称",
            dataIndex: "product_name",
            key: "product_name",
          },
          {
            title: "商品规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "入库数量",
            dataIndex: "warehouse_num",
            key: "warehouse_num",
          },
          {
            title: "销售数量",
            dataIndex: "out_warehouse_num",
            key: "out_warehouse_num",
          },
          {
            title: "库存数量",
            dataIndex: "product_num",
            key: "product_num",
          },
          {
            title: "库存状态",
            dataIndex: "status_text",
            key: "status_text",
          }
        ]
      });
      const $router = inject("$router");
      const $route = inject("$route");
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
        allNum
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
        allNum
      };

      onMounted(() => {
        search.value.type = $route.query.type;
        search.value.id = $route.query.id;
        tableHoosks.initData(getStockMore, search.value);
      });
      return {
        ...toRefs(state),
        ...tableHoosks
      };
    },
  };
</script>